import React, { useRef, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, useMediaQuery } from "@mui/material";
import Webcam from "react-webcam";

const CameraModal = ({ open, onClose, onCapture }) => {
  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleCaptureClick = () => {
    const image = webcamRef.current.getScreenshot();
    setCapturedImage(image);
  };

  const handleRetake = () => {
    setCapturedImage(null);
  };

  const handleConfirm = () => {
    onCapture(capturedImage);
    setCapturedImage(null);
  };

  const modalContentStyle = {
    width: isMobile ? "300px" : "500px",
    margin: "auto",
  };

  return (
    <Dialog open={open} fullScreen={isMobile}>
      <DialogTitle>Camera Capture</DialogTitle>
      <DialogContent>
        <Box sx={{ ...modalContentStyle, textAlign: "center" }}>
          {capturedImage ? (
            <img src={capturedImage} alt="Captured" style={{ width: "100%", borderRadius: "8px" }} />
          ) : (
            <Webcam
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{ facingMode: "user", width: { ideal: 1280 }, height: { ideal: 720 } }}
              style={{ width: "100%", borderRadius: "8px", height:"60%" }}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => { setCapturedImage(null); onClose(); }} color="secondary">
          Cancel
        </Button>
        {capturedImage ? (
          <>
            <Button onClick={handleRetake} color="primary">
              Retake
            </Button>
            <Button onClick={handleConfirm} variant="contained" color="primary">
              Confirm
            </Button>
          </>
        ) : (
          <Button onClick={handleCaptureClick} variant="contained" color="primary">
            Capture
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CameraModal;
